///<reference path="Utilities.ts"/>
///<reference path="../typings/jquery-validation-unobtrusive/jquery-validation-unobtrusive.d.ts"/>

((($:JQueryStatic) => {
    $.fn.triggerTesterAccreditationCheck = function (options) {

        var settings = $.extend({
            dialogId: null,
            testDateCtlId: null,
            testerCtlId: null,
            episodeId: null,
            species: null,
            checkUrl: null,
            cancelAndReallocateUrl: null
        }, options);

        return this.each(function () {

            $(this).change(() => {

                var testDateCtl = $(settings.testDateCtlId);
                var testerCtl = $(settings.testerCtlId);

                if (testDateCtl.val() != "" && testerCtl.val() != "") {
                    validateTesterAccreditation(testerCtl, testDateCtl);
                }

                return true;
            });

            function validateTesterAccreditation(tester, testDate) {
                var testDataValidationResult = $(testDate).validate();
                if (!testDataValidationResult) {
                    return;
                }

                // Convert to invariant culture for GET request
                var testDateAsDate = Ahb.Utilities.nzDateStringToInvariant($(testDate).val());

                $.getJSON(settings.checkUrl, { testerId: tester.val(), testDate: testDateAsDate, species: settings.species }, data => {

                    if (!data) {
                        return;
                    }

                    var isAccredited = data.result;
                    if (isAccredited) {
                        return;
                    }

                    $(settings.dialogId).insiteDialog({
                        cancelButtonName: null, // Indicate we don't want a Cancel button
                        closeCallback: () => {
                            tester.val("");
                            tester.trigger("chosen:updated");
                        },
                        alternativeSaveCommands: [{
                            // This one does nothing, just closes the dialog.
                            buttonName: "Select a new tester"
                        }, {
                            buttonName: "Cancel and reallocate",
                            callback: (form, resultData) => {
                                if (resultData != null) {
                                    window.location.href = resultData.result;
                                }
                            },
                            url: settings.cancelAndReallocateUrl,
                            data: Ahb.Utilities.addPostTokens({ episodeId: settings.episodeId, testerId: tester.val(), testDate: testDateAsDate })
                        }]
                    });
                });
            }
        });
    };
})(jQuery));



// WEBPACK FOOTER //
// ./ScriptsTS/AhbTesterAccreditation.ts